<template>
  <div
    class="pch-textchat-done"
  >
    <div
      style="height: calc(100% - 35px); overflow-y: auto;"
    >
      <div class="messageBox business">
        <div class="message">
          <span class="bgrd" :style="{ backgroundColor: $store.getters.color }"></span>
          <span>{{ $renderSmartText($store.getters.widgetSettings.message_text || 'Enter your information and our team will text you shortly.') }}</span>
        </div>
      </div>

      <div class="messageBox customer">
        <div class="message">
          <span class="bgrd"></span>
          <span>{{ $store.state.messageText }}</span>
        </div>
      </div>

      <div class="messageBox business">
        <div class="message">
          <span class="bgrd" :style="{ backgroundColor: $store.getters.color }"></span>
          <span>Hi {{ $store.state.contact && $store.state.contact.first_name }}!  We’ve received your message and will respond via text soon!</span>
        </div>
      </div>

      <div
        style="opacity: 0.6"
      >You can close this chat at any<br />time and we’ll text you!</div>
    </div>
    <div
      style="height: 35px"
    >
      <branding-view />
    </div>
  </div>
</template>

<script>
import BrandingView from '../Branding'

export default {
  components: {
    BrandingView
  }
}
</script>

<style lang="scss">
.pch-textchat-done {
  padding: 12px;
  height: 100%;
}
</style>
